import React from 'react';
import moment from 'moment';
import { truncate } from '../../../helpers';
import { getConfig } from '../../../utils/config';
import { useHistory } from 'react-router-dom';
import { winnreAuth, winnreNoAuth } from '../../../utils/axios';
import { useSelector } from 'react-redux';
import useHomeBlogs from '../BlogLayoutVertical1/data';

function BlogLayoutList({ className, headingClass, titleClass ,listTitleClass, summaryClass, listTitle, bgUrl, buttonClass, linearGradient, backgroundImage, bannerContainerClassName }) {
    const config = getConfig();
    const { blogs } = useHomeBlogs();
    const history = useHistory();

    const clientWebview = useSelector((state) => state.webView.clientWebview);
    const internalWebview = useSelector(
        (state) => state.webView.internalWebview
    );
    const clickThroughMobile = clientWebview || internalWebview;

    const isUserAuthenticated = useSelector(
        (state) => state.auth.isAuthenticated
    );
    const userId = useSelector((state) => state.auth.userId);
    const blogClickedHandler = (blogId, visibleToAll) => {
        if (isUserAuthenticated) {
            winnreAuth({
                method: 'POST',
                url: `winnre/user/blogs/trackClick?blogId=${blogId}&userId=${userId}&sourcePlatform=${clickThroughMobile ? 'MOBILE' : 'WEBSITE'
                    }`
                // headers: headers2
            })
                .then(() => { })
                .catch(() => { });
        } else {
            winnreNoAuth({
                method: 'POST',
                url: `winnre/user/blogs/trackClick?blogId=${blogId}&sourcePlatform=${clickThroughMobile ? 'MOBILE' : 'WEBSITE'
                    }`
            })
                .then(() => { })
                .catch(() => { });
        }
        if (visibleToAll) {
            history.push(`/blogs/${blogId}`);
        } else {
            history.push(`/blogs`);
        }
    };
    

    return (
        <div
            className={
                className
                    ? className
                    : 'w-full h-auto flex flex-col-reverse lg:flex-row justify-center '
            }
        >   
            <div className={'w-full flex flex-col lg:flex-row  text-white bg-primary '}>

                <div className='w-full lg:w-[50%] p-10 md:p-16 xl:p-24 2xl:p-32'>
                    {blogs?.map((blog, index) =>
                        index === 0 && <div
                            key={blog.id}
                            className='flex flex-col justify-between'
                        >

                            <h2 className={`text-white text-[23px] md:text-[27px] xl:text-[30px] 2xl:text-[32px] 3xl:text-[35px] leading-[1.2] tracking-tight font-medium uppercase ${config?.blogs?.fontHeading} ${titleClass || ''} `}
                            >
                                {blog.heading}
                            </h2>
                            <p className={` font-normal text-[16.5px] xl:text-[17px] mt-5 text-white ${config?.blogs?.fontBody} ${summaryClass || ''} ` } >{blog.summary}</p>
                            <button
                                className={`bg-primary-focus flex justify-center self-start float-left text-[13px] xl:text-[16px] text-white py-1.5 px-4 md:px-4 mt-10 rounded-full ${config?.blogs?.fontBody} ${buttonClass || ''}`}
                                onClick={() =>
                                    blogClickedHandler(blog.id, blog.visibleToAll)
                                }
                            >
                                READ MORE
                                <span className=" inline-block self-center h-4 my-auto">
                                    <img
                                        src={`data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 56.16 11.59'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:none;stroke:%23fff;stroke-miterlimit:10;%7D%3C/style%3E%3C/defs%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Layer_1-2' data-name='Layer 1'%3E%3Cline class='cls-1' y1='5.62' x2='55' y2='5.62'/%3E%3Cpolyline class='cls-1' points='48.5 0.39 51.93 3.09 55.35 5.79 51.93 8.49 48.5 11.19'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E`
                                           
                                        }
                                        className="h-4 w-[40px] xl:w-[50px] ml-4 "
                                    />
                                </span>
                            </button>
                        </div>
                    )}


                </div>

                <div className="w-full lg:w-[50%] h-full bg-bottom bg-cover no-repeat p-10 md:p-16 xl:p-24 2xl:p-32"
                    style={{
                        backgroundImage: `linear-gradient(${'90deg' || linearGradient?.deg}, rgba(${linearGradient?.R || linearGradient?.R1}, ${linearGradient?.G || linearGradient?.G1}, ${linearGradient?.B || linearGradient?.B1}, ${linearGradient?.opacity || linearGradient?.opacity1}),rgba(${linearGradient?.R || linearGradient?.R2}, ${linearGradient?.G || linearGradient?.G2}, ${linearGradient?.B || linearGradient?.B2}, ${linearGradient?.opacity || linearGradient?.opacity2})), url('${backgroundImage}')`
                    }}
                >
                    <div>
                        <div className='flex space-x-5 pb-8'>
                            <img src='https://cdn.loyalie.in/1725862962923_blog%20icon' className='w-6 h-6 2xl:w-8 2xl:h-8' />
                            <h2 className={` text-white text-[23px] md:text-[27px] 3xl:text-[20px]  font-medium uppercase  break-words leading-[1] ${config?.blogs?.fontHeading} ${headingClass || ''}`}>Our Latest Blogs</h2>
                        </div>
                        <ul class="list-none space-y-4">
                            {blogs?.slice(1, 6).map((blog) => {
                                return (
                                    <li key={blog.id} onClick={() =>
                                        blogClickedHandler(blog.id, blog.visibleToAll)
                                    } ><button className={`font-medium text-left uppercase text-[17px] xl:text-[19px] text-white ${config?.blogs?.fontBody} ${listTitleClass || ''}`} title={blog.heading} ><span className='mr-2'>⁃</span> {blog.heading}</button></li>
                                )
                            })} 

                        </ul>
                    </div>

                </div>

            </div>
        </div>
    );
}

export default BlogLayoutList;
